import React from "react";
import iconConfig1 from "../Resources/img/icon-config-1.png";
import iconConfig2 from "../Resources/img/icon-config-2.png";
import iconConfig3 from "../Resources/img/icon-config-3.png";
import iconLink from "../Resources/img/icon-arrow-right.png";

const CardConfig = ({ item, openModal }) => {
  let image = "";
  switch (item.id) {
    case 0:
      image = iconConfig1;
      break;
    case 1:
      image = iconConfig2;
      break;
    case 3:
      image = iconConfig3;
      break;
  }

  return (
    <div className="cardConfig">
      <div className="cardConfig__container" onClick={() => openModal(item.id)}>
        <div className="cardConfig__container__header">
          <img
            src={image}
            alt=""
            className="cardConfig__container__header__image"
          />
        </div>
        <div className="cardConfig__container__body">
          <p className="cardConfig__container__body__title">{item.title}</p>
          <span className="cardConfig__container__body__link">
            {item.link} <img src={iconLink} />
          </span>
        </div>
      </div>
    </div>
  );
};

export default CardConfig;
